<script>
/** @type {{ row: any, column: any, api?: any }} */
let { row } = $props();

const tagColorMapping = {
	Character: "info",
	Location: "light",
	Organization: "warning",
	Phrase: "success",
	Other: "secondary",
};

let tags = $derived(Array.isArray(row?.tags) ? row.tags : []);
</script>

{#if tags.length > 0}
	<div class="tags-cell">
		{#each tags as tag (tag.id ?? tag.term)}
			<span
				class="badge bg-{tagColorMapping[tag.type] || 'secondary'} {tagColorMapping[tag.type] === 'light' ? 'text-dark' : ''} text-custom-small"
				title={tag.definition || ""}
			>
				{tag.term || ""}
			</span>
		{/each}
	</div>
{/if}

<style>
.tags-cell {
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	gap: 0.25rem;
	height: 100%;
	width: 100%;
	overflow-x: auto;
	white-space: nowrap;
	user-select: text;
}
</style>
